export class ProductStandard {
  public static fc2 = new ProductStandard('FC-2');
  public static apiMetadataValidator = new ProductStandard('Api-Metadata-Validator');

  constructor(
    public readonly key: string,
    public readonly displayKey?: string,
    // NOTE: this is the date for end of check
    public deprecationDate?: Date,
    public endOfVisualisationDate?: Date,
  ) {
    this.displayKey = displayKey || key;
    this.deprecationDate = deprecationDate;
    this.endOfVisualisationDate = endOfVisualisationDate;
  }

  generateTestId(selector: string, suffix?: string) {
    return `${this.displayKey!.toLocaleLowerCase()}${selector}${suffix || ''}`;
  }

  toString() {
    return this.key;
  }

  isDeprecated() {
    return this.deprecationDate && this.deprecationDate < new Date();
  }

  isEndOfVisualisation() {
    return this.endOfVisualisationDate && this.endOfVisualisationDate < new Date();
  }

  static getByKey(key: string): ProductStandard | undefined {
    return ProductStandards.find((productStandard) => productStandard.key === key);
  }

  static getByDisplayKey(displayKey: string): ProductStandard | undefined {
    return ProductStandards.find((productStandard) => productStandard.displayKey === displayKey);
  }
}

export const ProductStandards: ProductStandard[] = Object.keys(ProductStandard)
  .filter((key: string) => (ProductStandard as unknown as Record<string, unknown>)[key] instanceof ProductStandard)
  .map((key: string) => (ProductStandard as unknown as Record<string, ProductStandard>)[key]);
